<template>
  <div>
    <div class="title">
      <div class="title--newFont">基本资料</div>
      <div style="text-align: right">
        <el-button type="primary" v-if="homeState == 0" size="mini" @click="getList()"
          >刷新</el-button
        >
        <el-button type="primary" v-if="homeState == 0" size="mini" @click="updateClick()"
          >修改</el-button
        >
        <el-button v-if="homeState == 1" type="primary" size="mini" @click="saveClick()"
          >提交审核</el-button
        >
        <el-button v-if="homeState == 1" type="info" size="mini" @click="closeClick()"
          >取消</el-button
        >
      </div>
    </div>
    <hr />
    <!-- 查看 -->
    <div v-if="homeState == 0">
      <div class="titleSpan">基础资料</div>
      <el-descriptions
        style="margin: 10px 0px"
        size="small"
        :column="3"
        border
        :label-style="labelStyle"
      >
        <el-descriptions-item contentStyle="width: 180px">
          <template slot="label">公司名称：</template>
          <span>{{ singleData.baseSupplierName }}</span>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 180px">
          <template slot="label">主营品牌：</template>
          <span>{{ singleData.baseMainBrand }}</span>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 180px">
          <template slot="label">法定代表人：</template>
          <span>{{ singleData.baseSupplierCorporate }}</span>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 180px">
          <template slot="label">联系人：</template>
          <span>{{ singleData.baseSupplierContactsName }}</span>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 180px">
          <template slot="label">联系方式：</template>
          <span>{{ singleData.baseSupplierPhone }}</span>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 180px">
          <template slot="label">联系地址：</template>
          <span>{{ singleData.baseSupplierAddress }}</span>
        </el-descriptions-item>
      </el-descriptions>
      <div class="titleSpan">开票信息</div>
      <div style="margin: 10px 0px">
        <div class="textItemSpan">公司名称：</div>
        <span>{{ singleData.invoicedefaultCompanyName }}</span>
        <br />
        <div class="textItemSpan">信用代码：</div>
        <span>{{ singleData.invoicedefaultUnifiedCode }}</span>
        <br />
        <div class="textItemSpan">地址、电话：</div>
        <span>{{ singleData.invoicedefaultAddress }}</span>
        <br />
        <div class="textItemSpan">银行账号：</div>
        <span>{{ singleData.invoicedefaultBankAccount }}</span>
        <br />
        <div class="textItemSpan">开 户 行：</div>
        <span>{{ singleData.invoicedefaultBank }}</span>
      </div>
      <hr />
      <myHtml
        :maxHeight="this.$root.tableHeight - 50"
        :id="'bill_one'"
        :columnType="'columnIndex'"
        :list="list"
        :titleList="titleList"
        :tableBtnList="['取消']"
        @btnClick="btnClick"
        ref="myTable"
      ></myHtml>
    </div>
    <!-- 修改 -->
    <div v-if="homeState == 1">
      <div class="titleSpan">基础资料</div>
      <el-descriptions
        style="margin: 10px 0px"
        size="small"
        :column="3"
        border
        :label-style="labelStyle"
      >
        <el-descriptions-item contentStyle="width: 180px">
          <template slot="label">公司名称：</template>
          <el-input v-model="updateData.baseSupplierName"></el-input>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 180px">
          <template slot="label">主营品牌：</template>
          <el-input v-model="updateData.baseMainBrand"></el-input>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 180px">
          <template slot="label">法定代表人：</template>
          <el-input v-model="updateData.baseSupplierCorporate"></el-input>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 180px">
          <template slot="label">联系人：</template>
          <el-input v-model="updateData.baseSupplierContactsName"></el-input>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 180px">
          <template slot="label">联系方式：</template>
          <el-input v-model="updateData.baseSupplierPhone"></el-input>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 180px">
          <template slot="label">联系地址：</template>
          <el-input v-model="updateData.baseSupplierAddress"></el-input>
        </el-descriptions-item>
      </el-descriptions>
      <div class="titleSpan">开票信息</div>
      <div style="margin: 10px 0px">
        <div class="textItemSpan">公司名称：</div>
        <el-input
          v-model="updateData.invoicedefaultCompanyName"
          class="textItemInput"
        ></el-input>
        <div class="textItemSpan">信用代码：</div>
        <el-input
          v-model="updateData.invoicedefaultUnifiedCode"
          class="textItemInput"
        ></el-input>
        <div class="textItemSpan">地址、电话：</div>
        <el-input
          v-model="updateData.invoicedefaultAddress"
          class="textItemInput"
        ></el-input>
        <div class="textItemSpan">银行账号：</div>
        <el-input
          v-model="updateData.invoicedefaultBankAccount"
          class="textItemInput"
        ></el-input>
        <div class="textItemSpan">开 户 行：</div>
        <el-input
          v-model="updateData.invoicedefaultBank"
          class="textItemInput"
        ></el-input>
      </div>
    </div>
  </div>
</template>
<script>
import {
  supplier_view,
  pmgtCooperateDraftDoc_list,
  pmgtCooperateDraftDoc_add,
  pmgtCooperateDraftDoc_delete,
} from "@/api/myController/purchase";
import { getCurrentTime } from "@/utils/myUtils";
export default {
  name: "supplier_basic",
  data() {
    return {
      // *************主表状态
      labelStyle: {
        "text-align": "center",
        "font-weight": "600",
        width: "80px",
        "word-break": "keep-all",
      },
      // 修改的数据
      updateData: {},
      // 默认数据
      singleData: {},
      // 页面状态0.正常，1.修改
      homeState: 0,
      //
      list: [],
      titleList: [
        {
          id: 11,
          name: "标题",
          value: "cooperateDraftTitle",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: true,
        },
        {
          id: 11,
          name: "修改类型",
          value: "checkType",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: true,
        },
        {
          id: 9,
          name: "执行状态",
          value: "statusExecution",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionKey: "",
          selectOptionList: [
            {
              label: "已执行",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
              fontSize: "",
            },
            {
              label: "未执行",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
              fontSize: "",
            },
          ],
          canEdit: true,
        },
        {
          id: 9,
          name: "审核状态",
          value: "statusCheck",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionKey: "",
          selectOptionList: [
            {
              label: "已审核",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
              fontSize: "",
            },
            {
              label: "未审核",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
              fontSize: "",
            },
          ],
          canEdit: true,
        },
        {
          id: 11,
          name: "创建时间",
          value: "createTime",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: true,
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 修改
    getList() {
      supplier_view({ supplierId: this.getUserInfo.supplierId }).then((res) => {
        this.singleData = res.data.data;
      });
      pmgtCooperateDraftDoc_list({
        pmgtCooperateDraftDocDtoFilter: {
          checkType: "基本信息",
        },
      }).then((res) => {
        this.list = res.data.data.dataList;
      });
    },
    // 点击按钮
    async btnClick(row, item, index, state) {
      switch (item) {
        case "取消":
          if (row.statusCheck == 0) {
            this.$confirm("确定取消？, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                pmgtCooperateDraftDoc_delete({
                  cooperateDraftDocId: row.cooperateDraftDocId,
                }).then((res) => {
                  this.$message.success("操作成功！");
                  this.getList();
                });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
          } else {
            this.$message({
              type: "info",
              message: "已审核状态不能进行取消！",
            });
          }
          break;
        default:
          break;
      }
    },
    updateClick() {
      this.updateData = JSON.parse(JSON.stringify(this.singleData));
      this.homeState = 1;
    },
    // 修改提交
    saveClick() {
      let json = {
        cooperateDraftTitle: "基本信息修改-" + getCurrentTime(),
        checkType: "基本信息",
        cooperateDraftDataDomain: JSON.stringify(this.updateData),
        supplierId: this.getUserInfo.supplierId,
        presenterId: this.getUserInfo.supplierId,
        presenterName: this.getUserInfo.showName,
        supplierName: this.getUserInfo.showName,
        supplierNumber: this.getUserInfo.supplierNumber,
        statusExecution: 0,
        statusCheck: 0,
        scheduleDocTime: getCurrentTime(),
      };
      pmgtCooperateDraftDoc_add({ pmgtCooperateDraftDocDto: json }).then((res) => {
        this.$message.success("操作成功！");
        this.getList();
        this.homeState = 0;
      });
    },
    // 取消
    closeClick() {
      this.homeState = 0;
    },
  },
};
</script>
<style lang="less" scoped>
.titleSpan {
  color: #005ca3;
  font-size: 18px;
  border-left: 4px solid #005ca3;
  font-weight: 800;
  padding-left: 20px;
}

.textItemSpan {
  display: inline-block;
  width: 100px;
  text-align: right;
  margin-top: 30px;
  color: rgb(144, 147, 153);
  font-size: 12px;
  font-weight: 600;
}
.textItemInput {
  width: calc(100% - 100px);
}

::v-deep .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 6px !important;
  border: none;
}
::v-deep .el-descriptions-item__label.is-bordered-label {
  font-weight: 700;
  color: #909399;
  background: none;
}
</style>
